import { render, staticRenderFns } from "./UpdaPassMod.vue?vue&type=template&id=f632f854&scoped=true&"
import script from "./UpdaPassMod.vue?vue&type=script&lang=js&"
export * from "./UpdaPassMod.vue?vue&type=script&lang=js&"
import style0 from "./UpdaPassMod.vue?vue&type=style&index=0&id=f632f854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f632f854",
  null
  
)

export default component.exports